export const PATH_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/HIPOTECARIO`;
